/**
 * HS menu hover
 *
 * Toont mega-menu submenus bij mouseover op desktop.
 * Vervanging voor inline script in theme.liquid.
 *
 * Verschillen met origineel:
 * - Event listeners worden eenmalig toegevoegd (niet bij elke mouseover)
 * - Null-check voor pagina's zonder header__inline-menu
 * - Gebruik mouseenter/mouseleave (niet mouseover dat ook bubblet)
 * - Gewikkeld in DOMContentLoaded zodat DOM aanwezig is
 *
 * Changelog:
 * 10 mei 2026: aangemaakt als vervanging voor inline JS in theme.liquid
 */
(function () {
  'use strict';

  function init() {
    var inlineMenu = document.querySelector('.header__inline-menu');
    if (!inlineMenu) {
      return;
    }

    var detailsItems = inlineMenu.querySelectorAll('details');
    if (!detailsItems.length) {
      return;
    }

    detailsItems.forEach(function (item) {
      var ulElement = item.querySelector('ul');
      if (!ulElement) {
        return;
      }

      item.addEventListener('mouseenter', function () {
        item.setAttribute('open', 'true');
      });

      item.addEventListener('mouseleave', function () {
        item.removeAttribute('open');
      });

      ulElement.addEventListener('mouseleave', function () {
        item.removeAttribute('open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
